import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { PageSource, getPageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import Link from 'components/Link/CustomLink'
import type { TCourse } from '../../../dataFetching'
import {
  trackCatalogPageRowViewed,
  trackSubcategoryCarouselNavClicked,
} from '../../../events'
import { usePageData } from '../../PageDataProvider'
import { SubcategoryInstructorCarousel } from './SubcategoryInstructorCarousel'

interface SubcategoryInstructorCarouselSectionProps {
  subcatId: number
  subcatSlug: string
  subcatTitle: string
  content: TCourse[]
}

export const SubcategoryInstructorCarouselSection = ({
  subcatId,
  subcatSlug,
  subcatTitle,
  content,
}: SubcategoryInstructorCarouselSectionProps) => {
  const { slug } = usePageData()
  const { t } = useTranslation('@mc/next')

  const onArrowClick = () => {
    trackSubcategoryCarouselNavClicked(slug, subcatId)
  }

  return (
    // The scroll-margin-top property does not work when changing the anchor within the same page
    // because it doesn't trigger a scroll event, and therefore, scroll-margin-top won't have an effect
    <div id={subcatSlug} style={{ paddingTop: '70px', marginTop: '-70px' }}>
      <TrackingContainer
        onFirstVisible={() =>
          trackCatalogPageRowViewed({
            rowName: `sub_category_carousel:${subcatTitle}`,
            categorySlug: slug,
          })
        }
      >
        <SubcategoryInstructorCarousel
          TitleComponent={
            <p className='d-block d-sm-inline-flex align-items-baseline'>
              <h3 className='mc-text-h4'>{subcatTitle}</h3>
              <Link
                href={paths.subcategoryPage(subcatSlug)}
                className='mc-ml-sm-3 mc-opacity--muted'
              >
                {t('common.seeAll')}
              </Link>
            </p>
          }
          content={content}
          carouselName={subcatTitle}
          trackProps={{
            // todo https://masterclass-dev.atlassian.net/browse/PEN-3861: check if we'll need this prop or we can delete it
            categorySlug: slug,
            pageSource: getPageSource() || PageSource.CATEGORY,
            rowIndex: 3,
            carousel: 'sub_category_carousel',
          }}
          onClickNext={onArrowClick}
          onClickPrev={onArrowClick}
        />
      </TrackingContainer>
    </div>
  )
}
